export const MonkeyTest = () => {
  const paths = [
    {
      id: "path1",
      d: "m447.22,469.9c-.63.18-1.25.42-1.89.52-5.46.82-10.93,1.62-16.4...",
      color: "var(--primary-color)",
      label: "Corps principal"
    },
    {
      id: "path2",
      d: "m409.6,120.9c.06,6.95-1.06,13.65-3.06,20.26-2.12,6.98...",
      color: "var(--secondary-color)",
      label: "Bras"
    },
    {
      id: "path3",
      d: "m341.17,160.15c-2.39,1.63-4.26,2.9-6.13,4.17.12.20...",
      color: "var(--neutral-color)",
      label: "Queue"
    }
  ];

  return (
    <div className="monkey-test">
      <div className="monkey-test-grid">
        {paths.map((path) => (
          <div key={path.id} className="monkey-test-item">
            <h4 className="monkey-test-label">{path.label}</h4>
            <svg 
              viewBox="0 0 595.28 603.43" 
              className="monkey-test-svg"
            >
              <path d={path.d} fill={path.color} />
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
};
